<div class="filtering-panel d-flex flex-column h-100"
    [class.footer-padding]="!fixedHeader"
    data-automation-id="filter-panel"
    #panel
    role="region"
    aria-labelledby="refine"
    tabindex="0"
    [cdkTrapFocus]="fullscreen">
  <div class="sc-section-header">
    <div class="inline-container mx-6" [class.collapsed]="!expanded">
      <ng-container *ngIf="isKidsCatalog; else classicExpand">
        <app-kids-catalog-toggle
          data-automation-id="kids-catalog-container"
          (onExpandToggle)="onExpandToggle($event)"
          (closeFilterPanel)="closeFilterPanel()"
          [expanded]="expanded"
          [fullscreen]="fullscreen"></app-kids-catalog-toggle>
      </ng-container>

      <ng-template #classicExpand>
        <h2 class="header-custom" *ngIf="expanded"
            data-automation-id="filter-panel-refine-header-expanded"
            id="refine" translate>refineResults</h2>
        <button
          *ngIf="fullscreen; else expandButton"
          #closeButton
          data-automation-id="filter-panel-close-button"
          class="close-button ins-buttons button-secondary"
          aria-label="Close"
          (click)="closeFilterPanel()">
          <span class="icon-close"></span>
        </button>
        <ng-template #expandButton>
          <div class="expand-button-wrapper">
            <button
              (click)="onExpandToggle(!expanded)"
              data-automation-id="filter-panel-toggle-expand-button"
              class="expand-button ins-buttons button-secondary"
              [attr.aria-expanded]="expanded"
              [attr.aria-label]="(expanded ? 'facetPanelExpand' : 'facetPanelCollapse') | translate">
              <fa-icon [icon]="expanded ? angleLeftIcon : angleRightIcon" class="expand-button-icon"></fa-icon>
            </button>
            <h2 *ngIf="!expanded" class="header-custom-collapsed ml-2"
                data-automation-id="filter-panel-refine-header-collapsed" translate>refine</h2>
          </div>
        </ng-template>
      </ng-template>
    </div>
  </div>
  <div [class.d-none]="!expanded" class="overflow-auto flex-grow-1"
       data-automation-id="facets-wrapper">
    <ng-container *ngFor="let control of facetControls; trackBy: trackByKey">
      <div class="content-custom" [cdkPortalOutlet]="control.component" *ngIf="!(isRapidoMode && (control.key === 'LOCATIONS' || control.key === 'CATALOG_DATE'))"></div>
    </ng-container>
  </div>
  <div class="buttons-area py-4 px-6"
       *ngIf="isFacetsChanged && expanded"
       data-automation-id="filter-panel-footer"
       [class.fixed-bottom]="!fixedHeader"
       [style.width]="!fixedHeader ? panel.getBoundingClientRect().width + 'px' : 'inherit'">
    <button
      class="ins-buttons button-primary flint"
      data-automation-id="apply-term-button"
      translate
      (click)="onApplyFacets()">applyButton
    </button>
    <button
      class="ins-buttons button-secondary flint ml-3"
      data-automation-id="cancel-term-button"
      translate
      (click)="onCancelEditing()">cancelButton
    </button>
  </div>
</div>
